<!-- 解锁接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "PS0AF53Q",
          "policyName": "测试的策略",
          "tags": [
            "dmxy"
          ]
        },
        responseCode:{"data":{}, "message": "业务成功", "resultCode": 0, "status": 1},
        infoData: {
          explain: "智汇云车场：创建车场拦截策略接口",
          t_url: this.commonUrls.test+"createInterceptPolicy",
          p_url: this.commonUrls.prod+"createInterceptPolicy",
          precondition: "无",
          fitSystem: "智汇云车场（创建策略后，会根据车辆标签值，出场时拦截车辆）",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'policyName', info2: '是', info3: 'String', info4: '策略名' },
              { info1: 'tags', info2: '是', info3: 'String[]', info4: '标签值列表' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/createInterceptPolicy.vue